import BaseResource from '@/lib/data/resource/BaseResource'

export default class CrossCurrencySwapFrequencyItemResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.displayFrequency = payload.displayFrequency ?? ''
    this.frequency = payload.frequency ?? ''
  }

  /* PROPERTIES */

  /* METHODS */
}
